import { DBCollection } from '@/lib/utils/constants-shared';
import type { Firestore } from 'firebase/firestore';
import { collection, getDocs } from 'firebase/firestore';

import { fetchCollectionFromStorage } from '@/lib/utils/storage-bulk-data';
import type { FirebaseStorage } from 'firebase/storage';

/**
 * Fetch literary features by passage from DB (Storage first, then Firestore)
 */
export async function fetchLiteraryFeaturesByPassageFromDB(
  auth: any,
  db: Firestore,
  storage?: FirebaseStorage
): Promise<LiteraryFeaturesByPassage[]> {
  const fallback = async () => {
    const literaryFeaturesByPassageRef = collection(db, DBCollection.literaryFeaturesByPassage);
    const snapshot = await getDocs(literaryFeaturesByPassageRef);

    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      dateCreated: doc.data().dateCreated?.toDate(),
      dateUpdated: doc.data().dateUpdated?.toDate()
    })) as LiteraryFeaturesByPassage[];
  };

  if (storage) {
    return await fetchCollectionFromStorage<LiteraryFeaturesByPassage>(
      storage,
      `bulk-data/${DBCollection.literaryFeaturesByPassage}.json`,
      fallback
    );
  }

  return await fallback();
}

